export default __webpack_public_path__ + "static/media/4-2_image09@2x.41166404.png";